import { Flex, Icon, Link, Menu, MenuButton, Text } from "@chakra-ui/react";
import { Link as RRLink } from "react-router-dom";
import React from "react";

const NavItem = ({ navSize, icon, title, description, isActive, to }) => {
  // console.log({ isActive });
  return (
    <Flex
      mt="10px"
      flexDir="column"
      w="100%"
      alignItems={navSize === "small" ? "center" : "flex-start"}
    >
      <Menu placement="right" w="100%">
        <Link
          w="100%"
          as={RRLink}
          to={to}
          borderRadius={8}
          p={2}
          _hover={{
            backgroundColor: "#372C78",
            textDecoration: "none",
            color: "white",
          }}
          color={isActive ? "white" : "white"}
          transition="all 0.2s ease-in-out"
          backgroundColor={isActive ? "#372C78" : "none"}
        >
          <MenuButton w="100%">
            {navSize === "small" ? (
              <Flex direction="column" justify="center" align="center">
                <Icon as={icon} fontSize="xl" />
                <Text textTransform="capitalize" fontSize="12">
                  {title}
                </Text>
              </Flex>
            ) : (
              <Flex alignItems={"center"}>
                <Icon as={icon} fontSize="xl" />
                <Text ml={2} textTransform="capitalize" display={"block"}>
                  {title}
                </Text>
              </Flex>
            )}
          </MenuButton>
        </Link>
      </Menu>
    </Flex>
  );
};

export default NavItem;
